export default "__VITE_ASSET__00219d64__"